<template>
    <button
        class="button"
        :type="buttonType"
        :class="buttonClasses"
        :disabled="isDisabled"
        @click="onClick"
    >
        <template v-if="iconOnly">
            <i
                class="no-margin fa"
                :class="iconClass"
            />
        </template>
        <template v-else>
            {{ buttonText }}
            <span
                v-if="hasIcon"
                class="button--with-icon__icon-container">
                <i
                    class="no-margin fa"
                    :class="iconClass"
                />
            </span>
        </template>
    </button>
</template>

<script>
    /**
    * Component
    */
    export default {
        name: 'btn',
        props: {
            block: {
                type: Boolean,
                required: false,
                default: false
            },
            btnType: {
                type: String,
                required: false,
                default: null
            },
            canSubmit: {
                type: Boolean,
                required: false,
                default: false
            },
            icon: {
                type: String,
                required: false,
                default: null
            },
            text: {
                type: String,
                required: false,
                default: null
            },
            loading: {
                type: Boolean,
                required: false,
                default: false
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            loadingText: {
                type: String,
                required: false,
                default: null
            }
        },
        methods: {
            onClick () {
                this.$emit('on-click')
            }
        },
        computed: {
            iconOnly () {
                return this.hasIcon && !this.text
            },
            hasIcon () {
                return !!this.icon
            },
            buttonType () {
                return this.canSubmit ? 'submit' : 'button'
            },
            buttonClasses () {
                return {
                    'full-width': this.block,
                    'button--with-icon': this.hasIcon && !this.iconOnly,
                    'button--success': this.btnType === 'success',
                    'button--tertiary': this.btnType === 'tertiary',
                    'button--secondary': this.btnType === 'secondary',
                    'button--primary': this.btnType === 'primary',
                    'button--danger': this.btnType === 'danger'
                }
            },
            iconClass () {
                return this.loading ? 'fa-spin fa-cog' : this.icon
            },
            isDisabled () {
                return this.loading || this.disabled
            },
            buttonText () {
                return this.loading
                    ? (this.loadingText ? this.loadingText : this.text)
                    : this.text
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/Btn.vue